var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"logo",on:{"click":function($event){$event.stopPropagation();return _vm.gotoHome.apply(null, arguments)}}}),_c('div',{staticClass:"menu"},[_c('span',{on:{"click":function($event){return _vm.goMy()}}},[_vm._v("我")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }